import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const LineChats = (props) => {
  const jsonData = props.jsonData
  const [selectedChart, setSelectedChart] = useState('Dealer');

  const handleChartTypeChange = (e) => {
    setSelectedChart(e.target.value);
  };

  // console.log(jsonData)

  // console.log(selectedChart)

  
  // Extracting data for the selected chart
  const selectedData = jsonData[selectedChart];
  const series = [
    {
      name: selectedData.name,
      data: selectedData.chats[0].YAxis,
    },
  ];

  const options = {
    chart: {
      type: 'line',
      height: 450,
      toolbar:{
        show:false
      }
    },
    stroke: {
      curve: 'smooth',
      // dashArray: [2]

    },
    markers: {
      size: 6,
      strokeWidth: 2,
      shape: "circle",
    radius: 2,
    },
    xaxis: {
      categories: selectedData.chats[0].XAxis,
      tickPlacement: 'on',
            position: 'bottom',

      labels: {
        show: true,
        rotate: -75,
        rotateAlways: true,
        trim: true,
        hideOverlappingLabels: true,
          offsetX: 0,
          offsetY: 10,
          maxHeight: 70,
          minHeight: 50,

      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        gradientToColors: [ '#FDD835'],
        shadeIntensity: 1,
        type: 'horizontal',
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100, 100, 100]
      },
    }
    
  };

  return (
    <div>
      <select
        id="chart-type"
        value={selectedChart}
        onChange={handleChartTypeChange}
      >

        <option value="Dealer">Dealer</option>
        {/* <option value="Admin">Admin</option>
        <option value="Field">Field</option>
        <option value="Headquarter">Headquarter</option> */}
        <option value="Parts">Parts</option>
        <option value="Service">Service</option>

      </select>
      
``
        <div style={{borderRadius:"10px"}}>
           <ReactApexChart options={options} series={series} type="line" height={300} />
      </div>
    </div>
  );
};

export default LineChats;
